import {
  Camera,
  Scene,
  PlaneBufferGeometry,
  Vector2,
  ShaderMaterial,
  Mesh,
  WebGLRenderer,
} from 'three'

// eslint-disable-next-line max-len
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'

import { NoiseShader } from './noise-shader'
import { TwirlShader } from './twirl-shader'

class Bg {
  constructor(container) {
    this.container = container
    this.currScroll = 0
    this.oldScroll = 0
    this.tick = false

    this.init()
  }

  init = () => {
    this.camera = new Camera()
    this.camera.position.z = 1

    this.scene = new Scene()

    this.geometry = new PlaneBufferGeometry(2, 2)

    this.uniforms = {
      u_time: { type: 'f', value: 1.0 },
      u_resolution: { type: 'v2', value: new Vector2() },
      u_mouse: { type: 'v2', value: new Vector2() },
    }

    this.material = new ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: NoiseShader.vertexShader,
      fragmentShader: NoiseShader.fragmentShader,
    })

    this.mesh = new Mesh(this.geometry, this.material)
    this.scene.add(this.mesh)

    this.renderer = new WebGLRenderer()
    // this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize(window.innerWidth / 2, window.innerHeight / 2)

    this.container.appendChild(this.renderer.domElement)

    this.composer = new EffectComposer(this.renderer)
    this.composer.addPass(new RenderPass(this.scene, this.camera))

    this.twirlEffect = new ShaderPass(TwirlShader)
    // console.log(this.twirlEffect)
    this.composer.addPass(this.twirlEffect)

    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize, false)
    window.addEventListener('mousemove', this.onMouseMove)

    this.scrollContainer = document.querySelector('[data-text]')
    this.scrollContainer.addEventListener('scroll', () => {
      this.currScroll = this.scrollContainer.scrollTop
      this.onScroll()
    })

    this.animate()
  }

  onMouseMove = event => {
    this.uniforms.u_mouse.value.x = event.pageX
    this.uniforms.u_mouse.value.y = event.pageY
  }

  onWindowResize = () => {
    clearTimeout(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.renderer.setSize(window.innerWidth / 2, window.innerHeight / 2)
      this.uniforms.u_resolution.value.x = this.renderer.domElement.width
      this.uniforms.u_resolution.value.y = this.renderer.domElement.height
    }, 200)
  }

  onScroll = () => {
    const scrollDirection = this.currScroll >= this.oldScroll ? 'DOWN' : 'UP'

    if (scrollDirection === 'DOWN') {
      this.twirlEffect.uniforms.amount.value += 0.5
    } else {
      this.twirlEffect.uniforms.amount.value -= 0.5
    }

    this.oldScroll = this.currScroll
  }

  animate = () => {
    requestAnimationFrame(this.animate)
    this.render()
  }

  render = () => {
    this.uniforms.u_time.value += 0.05
    // this.twirlEffect.uniforms.amount.value += 0.05
    this.composer.render(this.scene, this.camera)
    // this.renderer.render(this.scene, this.camera)
  }
}

const bg = () => {
  const container = document.querySelector('[data-bg]')

  if (container) {
    new Bg(container)
  }
}

export default bg
